<template id="Obrigado">
    <v-ons-page id="ObrigadoPage">
      <v-ons-row width="90%" style="align-itens:center">
        <v-ons-col>
          <img src="../assets/img/logo.png" width="200px" style="margin:20px; padding-top:20px">
          <h3 class="titulo" style="margin-top:30px">Obrigado pela sua participação.</h3>
        </v-ons-col>
      </v-ons-row>
    </v-ons-page>
</template>
<style>

</style>
<script>

export default {
  name: 'Obrigado',
  key: 'Obrigado',
  data() {
    return {

    };
  },
   props: ['pageStack'],
  methods: {
    back(){ 
        this.$emit('pop');
    }
  }
}
</script>